import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import "../css/Login.css";

const AddCustomerVehicle = () => {
  const navigate = useNavigate();
  const server_url = localStorage.getItem("server_url");
  const grage_id = localStorage.getItem("grage_id");
  const company_id = localStorage.getItem("company_id");
  const garageData = JSON.parse(localStorage.getItem("garageData") || "{}");

  // Debounce timer refs
  const mobileSearchTimeoutRef = useRef(null);
  const plateSearchTimeoutRef = useRef(null);

  // Searchable Dropdown Component
  const SearchableDropdown = ({
    options = [],
    value,
    onChange,
    placeholder,
    name,
    error,
    loading,
    disabled,
    required,
  }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
      const filtered = options.filter((option) =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredOptions(filtered);
    }, [searchTerm, options]);

    useEffect(() => {
      const selected = options.find((opt) => opt.value == value);
      setSearchTerm(selected ? selected.label : "");
    }, [value, options]);

    const handleInputChange = (e) => {
      const term = e.target.value;
      setSearchTerm(term);
      setIsOpen(true);
    };

    const handleSelect = (selectedValue) => {
      setIsOpen(false);
      if (onChange) {
        onChange({ target: { name, value: selectedValue } });
      }
    };

    const displayValue = options.find((opt) => opt.value == value)?.label || "";
    const inputValue = isOpen ? searchTerm : displayValue;

    return (
      <div className="searchable-dropdown" ref={dropdownRef}>
        <div className={`input-group ${error ? "error" : ""}`}>
          <div className="input-icon">
            <i className="fas fa-search"></i>
          </div>
          <input
            type="text"
            className="form-input"
            placeholder={placeholder}
            value={inputValue}
            onChange={handleInputChange}
            onFocus={() => setIsOpen(true)}
            disabled={disabled || loading}
            readOnly={!isOpen}
            required={required}
          />
          {isOpen && (
            <ul
              className="dropdown-list"
              style={{ width: "70%", textAlign: "left" }}
            >
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <li
                    style={{
                      padding: "5px",
                      margin: "2px",
                    }}
                    key={option.value}
                    className="dropdown-item"
                    onClick={() => handleSelect(option.value)}
                  >
                    {option.label}
                  </li>
                ))
              ) : (
                <li className="dropdown-item no-results">No results found</li>
              )}
            </ul>
          )}
        </div>
        {error && (
          <div className="error-message">
            <i className="fas fa-exclamation-circle"></i>
            {error}
          </div>
        )}
        {loading && <div className="loading-message">Loading...</div>}
      </div>
    );
  };

  const [formData, setFormData] = useState({
    company_id: company_id,
    customer_id: "",
    customer_name: "",
    customer_mobile: "",
    customer_email: "",
    customer_area: "",
    customer_address: "",
    state_id: garageData.grage_state_id || "",
    city_id: garageData.grage_city_id || "",
    customer_pincode: garageData.grage_pincode || "",
    customer_company_name: "",
    vehicle_id: "",
    vehicle_reg_no: "",
    vehicle_reg_name: "",
    brand_id: "",
    model_id: "",
    sub_model_id: "",
    vehicle_type_id: "",
    fuel_type_id: "",
    vehicle_reg_date: "",
    vehicle_reg_valid_till: "",
    vehicle_engine_no: "",
    vehicle_chassis_no: "",
    vehicle_colour_name: "",
    vehicle_tyre_size: "",
    vehicle_battery_type: "",
    vehicle_puc_start_date: "",
    vehicle_puc_end_date: "",
    vehicle_cng_start_date: "",
    vehicle_cng_end_date: "",
  });

  const [files, setFiles] = useState({
    vehicle_side1_image: null,
    vehicle_side2_image: null,
    vehicle_front_image: null,
    vehicle_back_image: null,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchingCustomer, setSearchingCustomer] = useState(false);
  const [searchingVehicle, setSearchingVehicle] = useState(false);
  const [foundCustomers, setFoundCustomers] = useState([]);
  const [foundVehicles, setFoundVehicles] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [subModels, setSubModels] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [stateLoading, setStateLoading] = useState(true);
  const [cityLoading, setCityLoading] = useState(false);
  const [modelLoading, setModelLoading] = useState(false);
  const [subModelLoading, setSubModelLoading] = useState(false);

  // Track which fields were fetched vs manually entered
  const [fetchedFields, setFetchedFields] = useState({
    customer: false,
    vehicle: false,
  });

  // Dropdown visibility states
  const [showVehicleDropdown, setShowVehicleDropdown] = useState(false);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);

  // Refs for dropdowns
  const vehicleInputRef = useRef(null);
  const customerInputRef = useRef(null);
  const vehicleDropdownRef = useRef(null);
  const customerDropdownRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        vehicleDropdownRef.current &&
        !vehicleDropdownRef.current.contains(event.target) &&
        vehicleInputRef.current &&
        !vehicleInputRef.current.contains(event.target)
      ) {
        setShowVehicleDropdown(false);
      }
      if (
        customerDropdownRef.current &&
        !customerDropdownRef.current.contains(event.target) &&
        customerInputRef.current &&
        !customerInputRef.current.contains(event.target)
      ) {
        setShowCustomerDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Debounced search functions
  const debouncedSearchCustomer = useCallback((mobile) => {
    if (mobileSearchTimeoutRef.current) {
      clearTimeout(mobileSearchTimeoutRef.current);
    }
    
    mobileSearchTimeoutRef.current = setTimeout(() => {
      if (mobile && mobile.length >= 10) {
        searchCustomer(mobile);
      } else {
        setFoundCustomers([]);
        setShowCustomerDropdown(false);
      }
    }, 800); // Wait 800ms after last keystroke
  }, []);

  const debouncedSearchVehicle = useCallback((regNo) => {
    if (plateSearchTimeoutRef.current) {
      clearTimeout(plateSearchTimeoutRef.current);
    }
    
    plateSearchTimeoutRef.current = setTimeout(() => {
      if (regNo && regNo.length >= 3) {
        searchVehicle(regNo);
      } else {
        setFoundVehicles([]);
        setShowVehicleDropdown(false);
      }
    }, 800); // Wait 800ms after last keystroke
  }, []);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (mobileSearchTimeoutRef.current) {
        clearTimeout(mobileSearchTimeoutRef.current);
      }
      if (plateSearchTimeoutRef.current) {
        clearTimeout(plateSearchTimeoutRef.current);
      }
    };
  }, []);

  // Fetch states
  useEffect(() => {
    const fetchStates = async () => {
      if (!server_url) {
        toast.error("Server URL not configured.");
        return;
      }
      setStateLoading(true);
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id || "2");
        const response = await axios.post(
          `${server_url}state.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const stateOptions = (response.data.result || []).map((state) => ({
            value: state.state_id,
            label: state.state_name,
          }));
          setStates(stateOptions);
        } else {
          toast.error(response.data.error || "Failed to fetch states");
        }
      } catch (error) {
        console.error("Fetch states error:", error);
        toast.error("Unable to fetch states. Please try again.");
      } finally {
        setStateLoading(false);
      }
    };
    fetchStates();
  }, [server_url, company_id]);

  // Fetch brands, vehicle types, fuel types
  useEffect(() => {
    const fetchBrands = async () => {
      if (!server_url || !company_id) return;
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        const response = await axios.post(
          `${server_url}brand.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const brandOptions = (response.data.result || []).map((brand) => ({
            value: brand.brand_id,
            label: brand.brand_name,
          }));
          setBrands(brandOptions);
        } else {
          setBrands([]);
        }
      } catch (error) {
        console.error("Fetch brands error:", error);
        setBrands([]);
      }
    };
    const fetchVehicleTypes = async () => {
      if (!server_url || !company_id) return;
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        const response = await axios.post(
          `${server_url}vehicle_type.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const typeOptions = (response.data.result || []).map((type) => ({
            value: type.vehicle_type_id,
            label: type.vehicle_type_name,
          }));
          setVehicleTypes(typeOptions);
        } else {
          setVehicleTypes([]);
        }
      } catch (error) {
        console.error("Fetch vehicle types error:", error);
        setVehicleTypes([]);
      }
    };
    const fetchFuelTypes = async () => {
      if (!server_url || !company_id) return;
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        const response = await axios.post(
          `${server_url}fuel_type.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const fuelOptions = (response.data.result || []).map((fuel) => ({
            value: fuel.fuel_type_id,
            label: fuel.fuel_type_name,
          }));
          setFuelTypes(fuelOptions);
        } else {
          setFuelTypes([]);
        }
      } catch (error) {
        console.error("Fetch fuel types error:", error);
        setFuelTypes([]);
      }
    };
    fetchBrands();
    fetchVehicleTypes();
    fetchFuelTypes();
  }, [server_url, company_id]);

  // Fetch cities when state_id changes
  useEffect(() => {
    const fetchCities = async () => {
      if (!formData.state_id || !company_id) {
        setCities([]);
        return;
      }
      setCityLoading(true);
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        formDataToSend.append("state_id", formData.state_id);
        const response = await axios.post(
          `${server_url}city.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const cityOptions = (response.data.result || []).map((city) => ({
            value: city.city_id,
            label: city.city_name,
          }));
          setCities(cityOptions);
        } else {
          toast.error(response.data.error || "Failed to fetch cities");
          setCities([]);
        }
      } catch (error) {
        console.error("Fetch cities error:", error);
        toast.error("Unable to fetch cities. Please try again.");
        setCities([]);
      } finally {
        setCityLoading(false);
      }
    };
    fetchCities();
  }, [formData.state_id, server_url, company_id]);

  // Fetch models when brand_id changes
  useEffect(() => {
    const fetchModels = async () => {
      if (!formData.brand_id || !company_id) {
        setModels([]);
        setSubModels([]);
        return;
      }
      setModelLoading(true);
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        formDataToSend.append("brand_id", formData.brand_id);
        const response = await axios.post(
          `${server_url}model.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const modelOptions = (response.data.result || []).map((model) => ({
            value: model.model_id,
            label: model.model_name,
          }));
          setModels(modelOptions);
        } else {
          setModels([]);
        }
      } catch (error) {
        console.error("Fetch models error:", error);
        setModels([]);
      } finally {
        setModelLoading(false);
      }
    };
    fetchModels();
  }, [formData.brand_id, server_url, company_id]);

  // Fetch sub models when model_id changes
  useEffect(() => {
    const fetchSubModels = async () => {
      if (!formData.model_id || !company_id) {
        setSubModels([]);
        return;
      }
      setSubModelLoading(true);
      try {
        const formDataToSend = new URLSearchParams();
        formDataToSend.append("company_id", company_id);
        formDataToSend.append("model_id", formData.model_id);
        const response = await axios.post(
          `${server_url}sub_model.php`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (response.data.status == "1") {
          const subModelOptions = (response.data.result || []).map((sub) => ({
            value: sub.sub_model_id,
            label: sub.sub_model_name,
          }));
          setSubModels(subModelOptions);
        } else {
          setSubModels([]);
        }
      } catch (error) {
        console.error("Fetch sub models error:", error);
        setSubModels([]);
      } finally {
        setSubModelLoading(false);
      }
    };
    fetchSubModels();
  }, [formData.model_id, server_url, company_id]);

  // Search customer by mobile
  const searchCustomer = async (mobile) => {
    if (!mobile || mobile.length < 10) {
      setFoundCustomers([]);
      setShowCustomerDropdown(false);
      return;
    }
    setSearchingCustomer(true);
    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append("company_id", company_id);
      formDataToSend.append("customer_grage_id", grage_id);
      formDataToSend.append("searh_text", mobile);
      const response = await axios.post(
        `${server_url}customer.php`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (response.data.status == "1") {
        const customers = response.data.result || [];
        if (customers.length == 1) {
          const customer = customers[0];
          fillCustomerData(customer);
          if (customer.customer_id) {
            await searchVehiclesByCustomerId(customer.customer_id);
          }
          setShowCustomerDropdown(false);
        } else if (customers.length > 1) {
          setFoundCustomers(customers);
          setShowCustomerDropdown(true);
        } else {
          // No customer found
          setFoundCustomers([]);
          setShowCustomerDropdown(false);
        }
      } else {
        setFoundCustomers([]);
        setShowCustomerDropdown(false);
      }
    } catch (error) {
      console.error("Search customer error:", error);
      toast.error("Unable to search customer. Please try again.");
      setFoundCustomers([]);
      setShowCustomerDropdown(false);
    } finally {
      setSearchingCustomer(false);
    }
  };

  // Get single customer by mobile for handling duplicates
  const getCustomerByMobile = async (mobile) => {
    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append("company_id", company_id);
      formDataToSend.append("customer_grage_id", grage_id);
      formDataToSend.append("searh_text", mobile);
      const response = await axios.post(
        `${server_url}customer.php`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (
        response.data.status == "1" &&
        response.data.result &&
        response.data.result.length > 0
      ) {
        return response.data.result[0];
      }
      return null;
    } catch (error) {
      console.error("Get customer by mobile error:", error);
      return null;
    }
  };

  // Search vehicles by customer ID
  const searchVehiclesByCustomerId = async (customerId) => {
    if (!customerId) return;
    try {
      const formDataToSend = new URLSearchParams();
      formDataToSend.append("company_id", company_id);
      formDataToSend.append("customer_id", customerId || "");
      formDataToSend.append("vehicle_grage_id", grage_id || "");
      formDataToSend.append("vehicle_reg_no", "");
      const response = await axios.post(
        `${server_url}vehicle.php`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (response.data.status == "1") {
        const vehicles = response.data.result || [];
        if (vehicles.length == 1) {
          fillVehicleData(vehicles[0]);
        } else if (vehicles.length > 1) {
          setFoundVehicles(vehicles);
          setShowVehicleDropdown(true);
        }
      } else {
        setFoundVehicles([]);
        setShowVehicleDropdown(false);
      }
    } catch (error) {
      console.error("Search customer vehicles error:", error);
      setFoundVehicles([]);
      setShowVehicleDropdown(false);
    }
  };

  // Search vehicle by registration number
  const searchVehicle = async (regNo) => {
    if (!regNo || regNo.length < 3) {
      setFoundVehicles([]);
      setShowVehicleDropdown(false);
      return;
    }
    setSearchingVehicle(true);
    try {
      const vehicleFormData = new URLSearchParams();
      vehicleFormData.append("company_id", company_id);
      vehicleFormData.append("vehicle_reg_no", regNo);
      vehicleFormData.append("customer_id", "");
      vehicleFormData.append("vehicle_grage_id", grage_id || "");
      const vehicleResponse = await axios.post(
        `${server_url}vehicle.php`,
        vehicleFormData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (vehicleResponse.data.status == "1") {
        const vehicles = vehicleResponse.data.result || [];
        if (vehicles.length == 1) {
          const vehicle = vehicles[0];
          fillVehicleData(vehicle);
          if (vehicle.customer_id) {
            await searchCustomerByCustomerId(vehicle.customer_id);
          }
          setShowVehicleDropdown(false);
        } else if (vehicles.length > 1) {
          setFoundVehicles(vehicles);
          setShowVehicleDropdown(true);
        } else {
          // No vehicle found
          setFoundVehicles([]);
          setShowVehicleDropdown(false);
        }
      } else {
        setFoundVehicles([]);
        setShowVehicleDropdown(false);
      }
    } catch (error) {
      console.error("Search vehicle error:", error);
      toast.error("Unable to search vehicle. Please try again.");
      setFoundVehicles([]);
      setShowVehicleDropdown(false);
    } finally {
      setSearchingVehicle(false);
    }
  };

  // Search customer by customer ID
  const searchCustomerByCustomerId = async (customerId) => {
    if (!customerId) return;
    try {
      const customerFormData = new URLSearchParams();
      customerFormData.append("company_id", company_id);
      customerFormData.append("customer_id", customerId);
      customerFormData.append("customer_grage_id", grage_id || "");
      customerFormData.append("searh_text", "");
      const customerResponse = await axios.post(
        `${server_url}customer.php`,
        customerFormData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (
        customerResponse.data.status == "1" &&
        customerResponse.data.result &&
        customerResponse.data.result.length > 0
      ) {
        fillCustomerData(customerResponse.data.result[0]);
      }
    } catch (error) {
      console.error("Search customer by ID error:", error);
    }
  };

  const fillCustomerData = (customer) => {
    setFormData((prev) => ({
      ...prev,
      customer_id: customer.customer_id || "",
      customer_name: customer.customer_name || "",
      customer_mobile: customer.customer_mobile || "",
      customer_email: customer.customer_email || "",
      customer_area: customer.customer_area || "",
      customer_address: customer.customer_address || "",
      state_id: customer.state_id || "",
      city_id: customer.city_id || "",
      customer_pincode: customer.customer_pincode || "",
      customer_company_name: customer.customer_company_name || "",
    }));
    setFoundCustomers([]);
    setShowCustomerDropdown(false);
    setFetchedFields((prev) => ({ ...prev, customer: true }));
  };

  const fillVehicleData = (vehicle) => {
    setFormData((prev) => ({
      ...prev,
      vehicle_id: vehicle.vehicle_id || "",
      vehicle_reg_no: vehicle.vehicle_reg_no || "",
      vehicle_reg_name: vehicle.vehicle_reg_name || "",
      brand_id: vehicle.brand_id || "",
      model_id: vehicle.model_id || "",
      sub_model_id: vehicle.sub_model_id || "",
      vehicle_type_id: vehicle.vehicle_type_id || "",
      fuel_type_id: vehicle.fuel_type_id || "",
      vehicle_reg_date: vehicle.vehicle_reg_date || "",
      vehicle_reg_valid_till: vehicle.vehicle_reg_valid_till || "",
      vehicle_engine_no: vehicle.vehicle_engine_no || "",
      vehicle_chassis_no: vehicle.vehicle_chassis_no || "",
      vehicle_colour_name: vehicle.vehicle_colour_name || "",
      vehicle_tyre_size: vehicle.vehicle_tyre_size || "",
      vehicle_battery_type: vehicle.vehicle_battery_type || "",
      vehicle_puc_start_date: vehicle.vehicle_puc_start_date || "",
      vehicle_puc_end_date: vehicle.vehicle_puc_end_date || "",
      vehicle_cng_start_date: vehicle.vehicle_cng_start_date || "",
      vehicle_cng_end_date: vehicle.vehicle_cng_end_date || "",
      customer_id: vehicle.customer_id || "",
    }));
    setFoundVehicles([]);
    setShowVehicleDropdown(false);
    setFetchedFields((prev) => ({ ...prev, vehicle: true }));
  };

  const handleSelectCustomer = (customer) => {
    fillCustomerData(customer);
    if (customer.customer_id) {
      searchVehiclesByCustomerId(customer.customer_id);
    }
  };

  const handleSelectVehicle = (vehicle) => {
    fillVehicleData(vehicle);
    if (vehicle.customer_id) {
      searchCustomerByCustomerId(vehicle.customer_id);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name == "vehicle_reg_no") {
      newValue = value.toUpperCase();
    }
    
    setFormData((prev) => {
      const newForm = { ...prev, [name]: newValue };
      if (name == "brand_id") {
        newForm.model_id = "";
        newForm.sub_model_id = "";
      } else if (name == "model_id") {
        newForm.sub_model_id = "";
      }
      if (name == "customer_mobile" && fetchedFields.customer) {
        newForm.customer_id = "";
        newForm.customer_name = "";
        newForm.customer_email = "";
        newForm.customer_area = "";
        newForm.customer_address = "";
        newForm.state_id = "";
        newForm.city_id = "";
        newForm.customer_pincode = "";
        newForm.customer_company_name = "";
      } else if (name == "vehicle_reg_no" && fetchedFields.vehicle) {
        newForm.vehicle_id = "";
        newForm.vehicle_reg_name = "";
        newForm.brand_id = "";
        newForm.model_id = "";
        newForm.sub_model_id = "";
        newForm.vehicle_type_id = "";
        newForm.fuel_type_id = "";
        newForm.vehicle_reg_date = "";
        newForm.vehicle_reg_valid_till = "";
        newForm.vehicle_engine_no = "";
        newForm.vehicle_chassis_no = "";
        newForm.vehicle_colour_name = "";
        newForm.vehicle_tyre_size = "";
        newForm.vehicle_battery_type = "";
        newForm.vehicle_puc_start_date = "";
        newForm.vehicle_puc_end_date = "";
        newForm.vehicle_cng_start_date = "";
        newForm.vehicle_cng_end_date = "";
      }
      return newForm;
    });
    
    setFetchedFields((prev) => {
      if (name == "customer_mobile") {
        return { ...prev, customer: false };
      } else if (name == "vehicle_reg_no") {
        return { ...prev, vehicle: false };
      }
      return prev;
    });

    // Use debounced search functions
    if (name == "customer_mobile") {
      setShowCustomerDropdown(true);
      debouncedSearchCustomer(newValue);
    } else if (name == "vehicle_reg_no") {
      setShowVehicleDropdown(true);
      debouncedSearchVehicle(newValue);
    }
    
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setFiles((prev) => ({ ...prev, [name]: files[0] }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.customer_name.trim()) {
      newErrors.customer_name = "Customer name is required";
    }
    if (!formData.customer_mobile.trim()) {
      newErrors.customer_mobile = "Mobile number is required";
    } else if (!/^\d{10}$/.test(formData.customer_mobile)) {
      newErrors.customer_mobile = "Please enter a valid 10-digit mobile number";
    }
    if (
      formData.customer_email &&
      !/\S+@\S+\.\S+/.test(formData.customer_email)
    ) {
      newErrors.customer_email = "Please enter a valid email address";
    }
    if (!formData.vehicle_reg_no.trim()) {
      newErrors.vehicle_reg_no = "Vehicle plate number is required";
    }
    if (!formData.vehicle_reg_name.trim()) {
      newErrors.vehicle_reg_name = "Vehicle Registration Name is required";
    }
    if (!formData.brand_id) {
      newErrors.brand_id = "Brand is required";
    }
    if (!formData.model_id) {
      newErrors.model_id = "Model is required";
    }
    if (!formData.sub_model_id) {
      newErrors.sub_model_id = "Sub Model is required";
    }
    if (!formData.vehicle_type_id) {
      newErrors.vehicle_type_id = "Vehicle Type is required";
    }
    if (!formData.fuel_type_id) {
      newErrors.fuel_type_id = "Fuel Type is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    try {
      // First, create/update customer
      let customerId = formData.customer_id;
      if (customerId) {
        // Update existing customer
        const customerPayload = {
          company_id: company_id,
          customer_id: customerId,
          customer_name: formData.customer_name,
          customer_mobile: formData.customer_mobile,
          customer_email: formData.customer_email,
          customer_area: formData.customer_area,
          customer_address: formData.customer_address,
          state_id: formData.state_id,
          city_id: formData.city_id,
          customer_pincode: formData.customer_pincode,
          customer_company_name: formData.customer_company_name,
        };
        const customerFormData = new URLSearchParams();
        for (const key in customerPayload) {
          customerFormData.append(key, customerPayload[key]);
        }
        customerFormData.append("customer_grage_id", grage_id || "");
        const customerResponse = await axios.post(
          `${server_url}update_customer.php`,
          customerFormData,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (customerResponse.data.status == "0") {
          toast.error(customerResponse.data.error);
          setLoading(false);
          return;
        }
      } else {
        // Create new customer
        const customerPayload = { ...formData };
        delete customerPayload.customer_id;
        delete customerPayload.vehicle_id;
        const customerFormData = new URLSearchParams();
        for (const key in customerPayload) {
          if (key.startsWith("vehicle_")) continue;
          customerFormData.append(key, customerPayload[key]);
        }
        customerFormData.append("customer_grage_id", grage_id || "");
        const customerResponse = await axios.post(
          `${server_url}add_customer.php`,
          customerFormData,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (customerResponse.data.status == "1") {
          customerId = customerResponse.data.customer_id;
        } else if (
          customerResponse.data.error &&
          customerResponse.data.error.includes("already exists")
        ) {
          toast("Customer already exists. Fetching details...");
          const existingCustomer = await getCustomerByMobile(
            formData.customer_mobile
          );
          if (existingCustomer) {
            fillCustomerData(existingCustomer);
            customerId = existingCustomer.customer_id;
          } else {
            toast.error("Customer not found.");
            setLoading(false);
            return;
          }
        } else {
          toast.error(customerResponse.data.error);
          setLoading(false);
          return;
        }
      }
      // Then, create/update vehicle
      const vehicleFormDataToSend = new FormData();
      vehicleFormDataToSend.append("vehicle_grage_id", grage_id || "");
      vehicleFormDataToSend.append("company_id", company_id);
      vehicleFormDataToSend.append("customer_id", customerId);
      vehicleFormDataToSend.append("brand_id", formData.brand_id || "");
      vehicleFormDataToSend.append(
        "vehicle_reg_no",
        formData.vehicle_reg_no || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_reg_name",
        formData.vehicle_reg_name || ""
      );
      vehicleFormDataToSend.append("model_id", formData.model_id || "");
      vehicleFormDataToSend.append("sub_model_id", formData.sub_model_id || "");
      vehicleFormDataToSend.append(
        "vehicle_type_id",
        formData.vehicle_type_id || ""
      );
      vehicleFormDataToSend.append("fuel_type_id", formData.fuel_type_id || "");
      vehicleFormDataToSend.append(
        "vehicle_reg_date",
        formData.vehicle_reg_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_reg_valid_till",
        formData.vehicle_reg_valid_till || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_engine_no",
        formData.vehicle_engine_no || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_chassis_no",
        formData.vehicle_chassis_no || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_colour_name",
        formData.vehicle_colour_name || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_tyre_size",
        formData.vehicle_tyre_size || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_battery_type",
        formData.vehicle_battery_type || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_puc_start_date",
        formData.vehicle_puc_start_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_puc_end_date",
        formData.vehicle_puc_end_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_cng_start_date",
        formData.vehicle_cng_start_date || ""
      );
      vehicleFormDataToSend.append(
        "vehicle_cng_end_date",
        formData.vehicle_cng_end_date || ""
      );
      if (files.vehicle_side1_image) {
        vehicleFormDataToSend.append(
          "vehicle_side1_image",
          files.vehicle_side1_image
        );
      }
      if (files.vehicle_side2_image) {
        vehicleFormDataToSend.append(
          "vehicle_side2_image",
          files.vehicle_side2_image
        );
      }
      if (files.vehicle_front_image) {
        vehicleFormDataToSend.append(
          "vehicle_front_image",
          files.vehicle_front_image
        );
      }
      if (files.vehicle_back_image) {
        vehicleFormDataToSend.append(
          "vehicle_back_image",
          files.vehicle_back_image
        );
      }
      let vehicleResponse;
      if (formData.vehicle_id) {
        vehicleFormDataToSend.append("vehicle_id", formData.vehicle_id);
        vehicleResponse = await axios.post(
          `${server_url}update_vehicle.php`,
          vehicleFormDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        vehicleResponse = await axios.post(
          `${server_url}add_vehicle.php`,
          vehicleFormDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      if (vehicleResponse.data.status == "0") {
        toast.error(vehicleResponse.data.error);
        setLoading(false);
        return;
      } else {
        toast.success(
          formData.vehicle_id
            ? "Customer and vehicle updated successfully!"
            : "Customer and vehicle added successfully!"
        );
        setFormData({
          company_id: company_id,
          customer_id: "",
          customer_name: "",
          customer_mobile: "",
          customer_email: "",
          customer_area: "",
          customer_address: "",
          state_id: garageData.grage_state_id || "",
          city_id: garageData.grage_city_id || "",
          customer_pincode: garageData.grage_pincode || "",
          customer_company_name: "",
          vehicle_id: "",
          vehicle_reg_no: "",
          vehicle_reg_name: "",
          brand_id: "",
          model_id: "",
          sub_model_id: "",
          vehicle_type_id: "",
          fuel_type_id: "",
          vehicle_reg_date: "",
          vehicle_reg_valid_till: "",
          vehicle_engine_no: "",
          vehicle_chassis_no: "",
          vehicle_colour_name: "",
          vehicle_tyre_size: "",
          vehicle_battery_type: "",
          vehicle_puc_start_date: "",
          vehicle_puc_end_date: "",
          vehicle_cng_start_date: "",
          vehicle_cng_end_date: "",
        });
        setFiles({
          vehicle_side1_image: null,
          vehicle_side2_image: null,
          vehicle_front_image: null,
          vehicle_back_image: null,
        });
        setFoundCustomers([]);
        setFoundVehicles([]);
        setShowVehicleDropdown(false);
        setShowCustomerDropdown(false);
        setFetchedFields({
          customer: false,
          vehicle: false,
        });
        setLoading(false);
        navigate("/vehicles", { replace: true });
        return;
      }
    } catch (error) {
      console.error("Submit error:", error);
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Unable to connect to server. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <div className="login-form-wrapper">
          <form className="login-form" onSubmit={handleSubmit}>
            {/* Vehicle Plate Number */}
            <div className="form-group" style={{ position: "relative" }}>
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Plate Number *
              </label>
              <div className="input-group" ref={vehicleInputRef}>
                <div className="input-icon">
                  <i className="fas fa-car"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_reg_no"
                  className={`form-input ${
                    errors.vehicle_reg_no ? "error" : ""
                  }`}
                  placeholder="Enter vehicle plate number"
                  value={formData.vehicle_reg_no}
                  onChange={handleChange}
                  onFocus={() => setShowVehicleDropdown(true)}
                  required
                />
              </div>
              {errors.vehicle_reg_no && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.vehicle_reg_no}
                </div>
              )}
              {searchingVehicle && (
                <div className="loading-message">Searching vehicle...</div>
              )}
              
              {/* Vehicle Results Dropdown */}
              {showVehicleDropdown && foundVehicles.length > 0 && (
                <div
                  ref={vehicleDropdownRef}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "white",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {foundVehicles.map((vehicle) => (
                      <li
                        key={vehicle.vehicle_id}
                        onClick={() => handleSelectVehicle(vehicle)}
                        style={{
                          padding: "10px",
                          borderBottom: "1px solid #eee",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                      >
                        <div>
                          <strong style={{ display: "block" }}>
                            {vehicle.vehicle_reg_no}
                          </strong>
                          <small style={{ color: "#666" }}>
                            {vehicle.vehicle_reg_name} • {vehicle.brand_name} • {vehicle.model_name}
                          </small>
                        </div>
                        <i className="fas fa-chevron-right" style={{ color: "#ccc" }}></i>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Customer Mobile */}
            <div className="form-group" style={{ position: "relative" }}>
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Customer Mobile *
              </label>
              <div className="input-group" ref={customerInputRef}>
                <div className="input-icon" style={{marginBottom:"25px"}}>
                  <i className="fas fa-mobile-alt"></i>
                </div>
                <input
                  type="text"
                  name="customer_mobile"
                  className={`form-input ${
                    errors.customer_mobile ? "error" : ""
                  }`}
                  placeholder="Enter 10-digit mobile number"
                  value={formData.customer_mobile}
                  onChange={handleChange}
                  onFocus={() => setShowCustomerDropdown(true)}
                  maxLength={10}
                  minLength={10}
                  required
                />
                <label>Note: Do not use +91 in mobile number</label>
              </div>
              {errors.customer_mobile && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.customer_mobile}
                </div>
              )}
              {searchingCustomer && (
                <div className="loading-message">Searching customer...</div>
              )}
              
              {/* Customer Results Dropdown */}
              {showCustomerDropdown && foundCustomers.length > 0 && (
                <div
                  ref={customerDropdownRef}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    backgroundColor: "white",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                    {foundCustomers.map((customer) => (
                      <li
                        key={customer.customer_id}
                        onClick={() => handleSelectCustomer(customer)}
                        style={{
                          padding: "10px",
                          borderBottom: "1px solid #eee",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f5f5f5"}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                      >
                        <div>
                          <strong style={{ display: "block" }}>
                            {customer.customer_name}
                          </strong>
                          <small style={{ color: "#666" }}>
                            {customer.customer_mobile} • {customer.customer_email}
                          </small>
                        </div>
                        <i className="fas fa-chevron-right" style={{ color: "#ccc" }}></i>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* Vehicle Details Section */}
            <hr style={{ margin: "20px 0", border: "1px solid #eee" }} />
            <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
              Vehicle Details
            </h3>

            {/* Vehicle Registration Name */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Registration Name *
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-file-signature"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_reg_name"
                  className={`form-input ${
                    errors.vehicle_reg_name ? "error" : ""
                  }`}
                  placeholder="Vehicle Registration Name"
                  value={formData.vehicle_reg_name}
                  onChange={handleChange}
                  required
                />
              </div>
              {errors.vehicle_reg_name && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.vehicle_reg_name}
                </div>
              )}
            </div>

            {/* Brand */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Brand *
              </label>
              <SearchableDropdown
                name="brand_id"
                options={brands}
                value={formData.brand_id}
                onChange={handleChange}
                placeholder="Select Brand"
                error={errors.brand_id}
                loading={false}
                required
              />
            </div>

            {/* Model */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Model *
              </label>
              <SearchableDropdown
                name="model_id"
                options={models}
                value={formData.model_id}
                onChange={handleChange}
                placeholder="Select Model"
                error={errors.model_id}
                loading={modelLoading}
                disabled={!formData.brand_id}
                required
              />
            </div>

            {/* Sub Model */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Sub Model *
              </label>
              <SearchableDropdown
                name="sub_model_id"
                options={subModels}
                value={formData.sub_model_id}
                onChange={handleChange}
                placeholder="Select Sub Model"
                error={errors.sub_model_id}
                loading={subModelLoading}
                disabled={!formData.model_id}
                required
              />
            </div>

            {/* Vehicle Type */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Type *
              </label>
              <SearchableDropdown
                name="vehicle_type_id"
                options={vehicleTypes}
                value={formData.vehicle_type_id}
                onChange={handleChange}
                placeholder="Select Vehicle Type"
                error={errors.vehicle_type_id}
                loading={false}
                required
              />
            </div>

            {/* Fuel Type */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Fuel Type *
              </label>
              <SearchableDropdown
                name="fuel_type_id"
                options={fuelTypes}
                value={formData.fuel_type_id}
                onChange={handleChange}
                placeholder="Select Fuel Type"
                error={errors.fuel_type_id}
                loading={false}
                required
              />
            </div>

            {/* Vehicle Engine No */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Engine No
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-cog"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_engine_no"
                  className="form-input"
                  placeholder="Engine Number"
                  value={formData.vehicle_engine_no}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Vehicle Chassis No */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Chassis No
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-barcode"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_chassis_no"
                  className="form-input"
                  placeholder="Chassis Number"
                  value={formData.vehicle_chassis_no}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Vehicle Colour */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Colour
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-palette"></i>
                </div>
                <input
                  type="text"
                  name="vehicle_colour_name"
                  className="form-input"
                  placeholder="Vehicle Colour"
                  value={formData.vehicle_colour_name}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Registration Date */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Registration Date
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-calendar-alt"></i>
                </div>
                <input
                  type="date"
                  name="vehicle_reg_date"
                  className="form-input"
                  placeholder="Registration Date"
                  value={formData.vehicle_reg_date}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Registration Valid Till */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Registration Valid Till
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-calendar-check"></i>
                </div>
                <input
                  type="date"
                  name="vehicle_reg_valid_till"
                  className="form-input"
                  placeholder="Registration Valid Till"
                  value={formData.vehicle_reg_valid_till}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Vehicle Left Side */}
            <div className="form-group" style={{display:"none"}}>
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Left Side
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-file-pdf"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_side1_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*,application/pdf"
                />
              </div>
            </div>

            {/* Vehicle Right Side */}
            <div className="form-group" style={{display:"none"}}>
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Right Side
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-file-pdf"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_side2_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*,application/pdf"
                />
              </div>
            </div>

            {/* Vehicle Front Image */}
            <div className="form-group" style={{display:"none"}}>
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Front Image
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-camera"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_front_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
            </div>

            {/* Vehicle Back Image */}
            <div className="form-group" style={{display:"none"}}>
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Vehicle Back Image
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-camera"></i>
                </div>
                <input
                  type="file"
                  name="vehicle_back_image"
                  className="form-input"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>
            </div>

            {/* Customer Details Section */}
            <hr style={{ margin: "20px 0", border: "1px solid #eee" }} />
            <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
              Customer Details
            </h3>

            {/* Customer Name */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Customer Name *
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-user"></i>
                </div>
                <input
                  type="text"
                  name="customer_name"
                  className={`form-input ${
                    errors.customer_name ? "error" : ""
                  }`}
                  placeholder="Customer Name *"
                  value={formData.customer_name}
                  onChange={handleChange}
                  required
                />
              </div>
              {errors.customer_name && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.customer_name}
                </div>
              )}
            </div>

            {/* Customer Email */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Customer Email
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <input
                  type="email"
                  name="customer_email"
                  className={`form-input ${
                    errors.customer_email ? "error" : ""
                  }`}
                  placeholder="Customer Email"
                  value={formData.customer_email}
                  onChange={handleChange}
                />
              </div>
              {errors.customer_email && (
                <div className="error-message">
                  <i className="fas fa-exclamation-circle"></i>
                  {errors.customer_email}
                </div>
              )}
            </div>

            {/* Customer Area */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Customer Area
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <input
                  type="text"
                  name="customer_area"
                  className="form-input"
                  placeholder="Customer Area"
                  value={formData.customer_area}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Customer Address */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Customer Address
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-home"></i>
                </div>
                <input
                  type="text"
                  name="customer_address"
                  className="form-input"
                  placeholder="Customer Address"
                  value={formData.customer_address}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* State */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                State
              </label>
              <SearchableDropdown
                name="state_id"
                options={states}
                value={formData.state_id}
                onChange={handleChange}
                placeholder="Select State"
                error={errors.state_id}
                loading={stateLoading}
              />
            </div>

            {/* City */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                City
              </label>
              <SearchableDropdown
                name="city_id"
                options={cities}
                value={formData.city_id}
                onChange={handleChange}
                placeholder="Select City"
                error={errors.city_id}
                loading={cityLoading}
                disabled={!formData.state_id}
              />
            </div>

            {/* Pincode */}
            <div className="form-group">
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Pincode
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-map-pin"></i>
                </div>
                <input
                  type="text"
                  name="customer_pincode"
                  className="form-input"
                  placeholder="Pincode"
                  value={formData.customer_pincode}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Company Name */}
            <div className="form-group" style={{display:"none"}}>
              <label
                style={{
                  textAlign: "left",
                  display: "block",
                  marginBottom: "5px",
                  fontWeight: "bold",
                }}
              >
                Customer Company Name
              </label>
              <div className="input-group">
                <div className="input-icon">
                  <i className="fas fa-building"></i>
                </div>
                <input
                  type="text"
                  name="customer_company_name"
                  className="form-input"
                  placeholder="Company Name"
                  value={formData.customer_company_name}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="login-button"
              disabled={loading || stateLoading}
            >
              <i className="fas fa-save"></i>
              {loading ? "Saving..." : "Save Customer & Vehicle"}
            </button>

            {/* Back Link */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCustomerVehicle;